export default __webpack_public_path__ + "static/media/ISKO CLASS-8 EXAM PATTERN 2025.96887454.pdf";